<script setup>
import { reactive } from 'vue';
import Alert from '@/Components/Alert.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  rows: {
    type: Number,
    default: 6,
    required: false
  },
  timeout: {
    type: Number,
    default: 5000,
    required: false
  }
});
const errors = reactive([]);

setTimeout(() => {
  errors.push(t('components.preloader.please_refresh'));
}, props.timeout);
</script>

<template>
  <Alert
    v-if="errors.length"
    variant="danger"
    :title="$t('components.preloader.an_error_has_occurred')"
    class="mb-3"
  >
    <div v-for="(error, index) in errors" :key="index">
      <p class="text-red-950">{{ error }}</p>
    </div>
  </Alert>
  <div class="flex flex-col gap-2">
    <div v-for="index in rows" :key="index" class="flex gap-2">
      <div class="bg-default/50 h-4 w-2/6 animate-pulse rounded-lg" />
      <div class="bg-default/50 h-4 w-2/6 animate-pulse rounded-lg" />
      <div class="bg-default/50 h-4 w-2/6 animate-pulse rounded-lg" />
    </div>
  </div>
</template>
